import { createRouter, createWebHistory } from 'vue-router';
import Waitlist from '../views/Waitlist.vue';
import TravelPage from '../views/TravelPage.vue';

const routes = [
  {
    path: '/',
    name: 'Waitlist',
    component: Waitlist,
  },
  {
    path: '/travel',
    name: 'Travel',
    component: TravelPage,
  },
  {
    path: '/preview',
    name: 'InvestorTeaser',
    component: () => import('../views/InvestorTeaser.vue'),
  },
  // Keep the old /overview link working for anyone it was already shared with.
  {
    path: '/overview',
    redirect: '/preview',
  },
  {
    path: '/full-deck',
    name: 'InvestorDeep',
    component: () => import('../views/InvestorDeep.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: (to) => {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    }
    // Always scroll to top when navigating between routes
    return { top: 0, behavior: 'instant' };
  },
});

export default router;
